import { render, staticRenderFns } from "./RedirectPay.vue?vue&type=template&id=5b158076&"
import script from "./RedirectPay.vue?vue&type=script&lang=js&"
export * from "./RedirectPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RedirectPay.vue"
export default component.exports